<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		ActionsContainer,
		AdvancedCard,
		Alert,
		Button,
		IconButton,
	} from '@Shelly/shelly-design-system/index';
	import { capFirstChar } from 'src/helpers/utilities';
	//Helpers
	import { getXT1TemplateStatus } from 'src/helpers/xt1_helpers/template_status_helpers';
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	import { findDeviceByIP } from 'src/helpers/xt1_helpers/ev_charger/ev_charger_helpers';
	//Components
	import EvChargerAutoBalanceModal from './EvChargerAutoBalanceModal.svelte';
	import EvChargerAutoBalanceError from './EvChargerAutoBalanceError.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device: Device;

	let showConfigWizard = false;
	let statuses: VCInterfaceStatus[];

	$: statuses = getXT1TemplateStatus(device.id);
	$: templateService = getTemplateService(device);

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout && templateService?.settings?.auto_balance?.enable !== true) {
			stickyBottomAction.set({
				onClick: () => (showConfigWizard = true),
				loading: false,
				disabled: false,
				label: $format('set_up_step', { default: 'set up' }),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Alert
	class="mb-s"
	heading={$format('ev_charger_auto_balance_info', {
		default:
			'Optimize charging by managing your charger’s current use, helping prevent overloads and maximize efficiency.',
	})}
/>
<EvChargerAutoBalanceError {device} />
{#if templateService?.settings?.auto_balance?.enable === true}
	<AdvancedCard
		{...findDeviceByIP(templateService.settings.auto_balance.em_ip)}
		isCondensed
		class="width--full"
	>
		<ActionsContainer orientation="horizontal" type="simple" slot="right">
			<IconButton
				aria-label={$format('button_edit', { default: 'Edit' })}
				id="iconbutton-1m5y2v3"
				icon="fas fa-pen"
				slot="first"
				on:click={() => {
					showConfigWizard = true;
				}}
			/>
		</ActionsContainer>
	</AdvancedCard>
{:else if !$showNewLayout}
	<Button
		size="m"
		class=" width-full"
		on:click={() => {
			showConfigWizard = true;
		}}
	>
		{capFirstChar($format('set_up_step', { default: 'set up' }))}
	</Button>
{/if}
{#if showConfigWizard}
	<EvChargerAutoBalanceModal {device} {statuses} bind:showModal={showConfigWizard} />
{/if}
